export const COMPANY = {
  name: "Hyper Consult SRL",
  address: "Via Caldera 21, 20153 Milano (MI)",
  piva: "14302280962",
  rea: "MI-2773920",
  pec: "hyperconsult@pec.it",
  email: "servizioclienti@vivitranquillo.com",
};

export function CompanyBox() {
  return (
    <div data-testid="legal-company-box" className="rounded-2xl border border-slate-200 bg-[#F8FAFC] p-5 text-sm leading-relaxed text-slate-600">
      <p className="font-display font-bold text-[#0A192F]">Titolare: {COMPANY.name}</p>
      <p className="mt-1">{COMPANY.address}</p>
      <p>P.IVA / C.F. {COMPANY.piva} · REA {COMPANY.rea}</p>
      <p>PEC: {COMPANY.pec}</p>
      <p>Email clienti: {COMPANY.email}</p>
    </div>
  );
}

export function LegalPage({ eyebrow, title, intro, testid, children }) {
  return (
    <div data-testid={testid || "legal-page"} className="bg-white">
      <section className="border-b border-slate-100 py-14 lg:py-20">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">{eyebrow}</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter text-[#0A192F] sm:text-5xl">{title}</h1>
          {intro && <p className="mt-5 text-base leading-relaxed text-slate-600">{intro}</p>}
          <p className="mt-4 text-sm text-slate-400">Ultimo aggiornamento: giugno 2026</p>
        </div>
      </section>
      <section className="py-12 lg:py-16">
        <div className="mx-auto max-w-3xl space-y-10 px-6 lg:px-8">{children}</div>
      </section>
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <div>
      <h2 className="font-display text-lg font-bold text-[#0A192F] md:text-xl">{n ? `${n}. ` : ""}{title}</h2>
      <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-slate-600">{children}</div>
    </div>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="mt-2 space-y-2 text-[15px] leading-relaxed text-slate-600">
      {items.map((it, i) => (
        <li key={i} className="flex gap-2">
          <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#10B981]" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
